import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModuleNav, ModuleNavItem } from '../../contexts/ModuleNavContext';

const SYSTEM_NAV_ITEMS: ModuleNavItem[] = [
  { to: '/system/tenants',   labelKey: 'nav.system.tenants',   end: true },
  { to: '/system/users',     labelKey: 'nav.system.users',     end: true },
  { to: '/system/pests',     labelKey: 'nav.system.pests',     end: true },
  { to: '/system/crops',     labelKey: 'nav.system.crops',     end: true },
  { to: '/system/integrity', labelKey: 'nav.system.integrity', end: true },
];

const SystemLayout: React.FC = () => {
  const { t } = useTranslation();
  const { setModule } = useModuleNav();

  useEffect(() => {
    setModule(t('nav.system.module'), SYSTEM_NAV_ITEMS);
    return () => setModule(null, null);
  }, [setModule, t]);

  return <Outlet />;
};

export default SystemLayout;
